import { LitElement, html, css, classMap } from '@hh/global.js'
class HHStickyAtc extends LitElement {
  static properties = {
    _state: {
      type: Number,
      state: true,
    },
  }

  constructor() {
    super()

    this.atcBounds = {}
    this.currentScrollTop = 0

    this._state = -1
  }

  connectedCallback() {
    super.connectedCallback()
    this.onScrollHandler = this.onScroll.bind(this)
    window.addEventListener('scroll', this.onScrollHandler)
    this.createObserver()
    this.onScroll()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    window.removeEventListener('scroll', this.onScrollHandler)
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.atcBounds = entries[0].intersectionRect
      observer.disconnect()
    })

    observer.observe(document.documentElement)
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop
    const bottom = this.atcBounds.bottom + 150
    const { top } = this.getBoundingClientRect()

    if (scrollTop > bottom) {
      requestAnimationFrame(this.hide.bind(this))
    } else {
      if (window.innerHeight - 80 <= top)
        requestAnimationFrame(this.hide.bind(this))
      else
        requestAnimationFrame(this.reset.bind(this))
    }

    this.currentScrollTop = scrollTop
  }

  hide() {
    if (this._state === 1) {
      return
    }
    this._state = 1
    this.classList.add('scrolled')
  }

  reset() {
    if (this._state === -1) {
      return
    }
    this._state = -1
    this.classList.remove('scrolled')
  }

  render() {
    return html`<div
        class="container ${classMap({ 'fixed': this._state === 1 })}"
      >
        <div class="inner">
          <slot></slot>
        </div>
      </div>`
  }

  static styles = css`
    @media (max-width: 749px) {
      .container {
        transform: translateY(0);
        transition: transform var(--hh-duration-long, 500ms);
      }

      .container.fixed {
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        transform: translateY(0);
        background-color: var(--hh-background, transparent);
        border-top: var(--hh-border-width, 0.1rem) solid var(--hh-border-color, #000);
        z-index: var(--hh-z-index, 100);
      }

      .fixed .inner {
        padding: var(--hh-sticky-padding, 1.5rem 2rem);
      }
    }
  `
}

customElements.define('hh-sticky-atc', HHStickyAtc)
